import { useQuery } from "@tanstack/react-query";
import { puellMultipleChartQueryOptions } from "@/services/queries/coinglass/coinglassQueries";
import type { PuellMultipleQueryParams } from "@/types/indices";

export const usePuellMultipleChart = (params?: PuellMultipleQueryParams) => {
  return useQuery(puellMultipleChartQueryOptions(params));
};
